<template>
  <div class="main-wrapper">
    <layout-header></layout-header>
    <layout-sidebar></layout-sidebar>

    <div class="page-wrapper" ref="formContainer">
      <div class="content container-fluid">

        <!-- HEADER -->
        <reports-header
          :title="title"
          :path="path"
          :text="text"
          :text1="text1"
          :search_data="searchform"
          :columns="originalColumn"
          :hasExportPermission="hasExportPermission"
        />

        <!-- SEARCH FORM -->
        <Form @submit="onSearch">
          <div class="row filter-row">

            <!-- Employee -->
			<!--
            <div class="col-sm-6 col-md-3" v-if="hasWritePermission">
              <div class="input-block mb-3 form-focus focused">
                <vue-select
                  :options="employee_list"
                  v-model="searchform.s_employee_id"
                  placeholder="-"
                />
                <label class="focus-label">Employee Name</label>
              </div>
            </div>  -->

            <!-- Year -->
            <div class="col-sm-6 col-md-3">
              <div class="input-block mb-3 form-focus select-focus">
                <vue-select
                  :options="Year"
                  v-model="searchform.year"
                  placeholder="-"
                />
                <label class="focus-label">Select Year</label>
              </div>
            </div>

            <!-- Month -->
            <div class="col-sm-6 col-md-2">
              <div class="input-block mb-3 form-focus select-focus">
                <vue-select
                  :options="Month"
                  v-model="searchform.month"
                  placeholder="-"
                />
                <label class="focus-label">Select Month</label>
              </div>
            </div>

            <!-- Search -->
            <div class="col-sm-6 col-md-2">
              <div class="d-grid">
                <button class="btn btn-success w-100 mb-3 submit-btn">Search</button>
              </div>
            </div>

            <!-- Clear -->
            <div class="col-sm-6 col-md-2">
              <div class="d-grid">
                <a class="btn btn-danger w-100 submit-btn" @click="clearForm">Clear</a>
              </div>
            </div>

          </div>
        </Form>

        <!-- GENDER TABLE + CHART -->
        <div class="row mt-4">

          <!-- TABLE -->
          <div class="col-md-6">
            <div class="bg-white p-3 rounded shadow-sm table-responsive">
              <h3 class="text-lg font-semibold mb-3">Gender Distribution</h3>

              <a-table :dataSource="genderTable" :pagination="false" :bordered="false">
                <a-table-column title="S.No" dataIndex="sno" key="sno" />
                <a-table-column title="Gender" dataIndex="gender" key="gender" />
                <a-table-column title="Count" dataIndex="count" key="count" />
              </a-table>
            </div>
          </div>

          <!-- PIE CHART -->
          <div class="col-md-6">
            <div class="bg-white p-3 rounded shadow-sm chart-box">
              <canvas ref="genderCanvas" class="gender-chart"></canvas>
            </div>
          </div>

        </div>

        <!-- TENURE TABLE + CHART -->
        <div class="row mt-4">

          <!-- TABLE -->
          <div class="col-md-6">
            <div class="bg-white p-3 rounded shadow-sm">
              <h3 class="text-lg font-semibold mb-3">Tenure Distribution</h3>

              <a-table :dataSource="tenureTable" :pagination="false" :bordered="false">
                <a-table-column title="S.No" dataIndex="sno" key="sno" />
                <a-table-column title="Tenure Range" dataIndex="range" key="range" />
                <a-table-column title="Count" dataIndex="count" key="count" />
              </a-table>
            </div>
          </div>

          <!-- PIE CHART -->
          <div class="col-md-6">
            <div class="bg-white p-3 rounded shadow-sm chart-box">
              <canvas ref="tenureCanvas" class="gender-chart"></canvas>
            </div>
          </div>

        </div>

      </div>
    </div>

  </div>
</template>
<script>
import axios from "axios";
import { Form } from "vee-validate";
import { notification } from "ant-design-vue";

import { Chart, ArcElement, Tooltip, Legend } from "chart.js";
Chart.register(ArcElement, Tooltip, Legend);

export default {
  components: { Form },

  data() {
    const years = [];
    const currentYear = new Date().getFullYear();
    for (let y = currentYear; y >= 2020; y--) years.push(y.toString());

    return {
      title: "Tardiness Reports",
      path: "Dashboard",
      text: "Tardiness Reports",
      text1: "Export Excel",

      Month: ["-", "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul","Aug","Sep","Oct","Nov","Dec"],
      Year: ["-", ...years],

      searchform: { s_employee_id: "", month: "", year: "" },

      genderTable: [],
      genderChart: null,
      genderdata: [],

      tenureTable: [],
      tenureChart: null
    };
  },

  methods: {

    /* ------------------------------
       Search
    ------------------------------ */
    onSearch() {
      this.loadCommonData({ params: { ...this.searchform } });
    },

    clearForm() {
      this.searchform = {
        s_employee_id: "",
        month: "",
        year: "",
      };
      this.loadCommonData({ params: this.searchform });
    },

    /* ------------------------------
       API CALL
    ------------------------------ */
    loadCommonData(params) {
	
	  let loader = this.$loading.show({
        // Optional parameters
        container: this.$refs.formContainer,
        canCancel: false,
      });
	  
      axios
        .get("/newleavereports/tardinessreport", params)
        .then((response) => {

          /* -------------------------------
             GENDER TABLE
          --------------------------------*/
          const mapLabel = { m: "Male", f: "Female", o: "Other", null: "Not Specified" };
          const apiGenderData = response.data.genderdata;

          this.genderTable = apiGenderData.map((item, index) => ({
            sno: index + 1,
            gender: mapLabel[item.gender] ?? "Not Specified",
            count: item.total,
          }));

          this.genderdata = apiGenderData;
          this.drawGenderChart();

          /* -------------------------------
             TENURE TABLE
          --------------------------------*/
          const apiTenure = response.data.tenuredata;

          this.tenureTable = Object.keys(apiTenure).map((key, index) => ({
            sno: index + 1,
            range: key,
            count: apiTenure[key]
          }));

          this.drawTenureChart();
		  
		  loader.hide();

        }).catch((error) => {
		
          loader.hide();

          var response = error.response;

          if (
            error.response.status == 401 &&
            response.data.message == "Unauthenticated."
          ) {
            localStorage.clear();

            notification.open({
              message: "Please Login",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });

            this.$router.push({ name: "login" }).catch(() => {});
          } else {
            this.errorMessage = error.message;
            notification.open({
              message: response.data.message,
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });
          }
        });
		
    },

    /* -------------------------------
       GENDER PIE CHART
    --------------------------------*/
    drawGenderChart() {
      const ctx = this.$refs.genderCanvas.getContext("2d");

      if (this.genderChart) this.genderChart.destroy();

      const mapLabel = { m: "Male", f: "Female", o: "Other", null: "Not Specified" };
      const labels = this.genderdata.map((i) => mapLabel[i.gender]);
      const values = this.genderdata.map((i) => i.total);

      this.genderChart = new Chart(ctx, {
        type: "pie",
        data: {
          labels,
          datasets: [{
            data: values,
            backgroundColor: ["#55aaff", "#ff6b8a", "#f8d35c", "#c7c7c7"],
          }],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          radius: "90%",
          plugins: { legend: { position: "bottom" } }
        },
      });
    },

    /* -------------------------------
       TENURE PIE CHART
    --------------------------------*/
    drawTenureChart() {
      const ctx = this.$refs.tenureCanvas.getContext("2d");

      if (this.tenureChart) this.tenureChart.destroy();

      const labels = this.tenureTable.map((i) => i.range);
      const values = this.tenureTable.map((i) => i.count);

      this.tenureChart = new Chart(ctx, {
        type: "pie",
        data: {
          labels,
          datasets: [{
            data: values,
            backgroundColor: [
              "#6b21a8", "#1e90ff", "#3fbf7f",
              "#ff9800", "#9e9e9e"
            ],
          }],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          radius: "90%",
          plugins: { legend: { position: "bottom" } }
        },
      });
    },

  },

  mounted() {
    this.loadCommonData({
      params: {},
    });
  },
};
</script>
<style scoped>
.chart-box {
  height: 320px;
  width: 100%;
  position: relative;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}

.gender-chart {
  width: 100% !important;
  height: 100% !important;
  max-width: 320px !important;
  max-height: 320px !important;
  object-fit: contain;
}
</style>
